type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info';

const variantClass: Record<BadgeVariant, string> = {
  default: 'b-grey',
  success: 'b-green',
  warning: 'b-amber',
  error: 'b-red',
  info: 'b-blue',
};

export default function Badge({ children, variant = 'default' }: { children: React.ReactNode; variant?: BadgeVariant }) {
  return <span className={`badge ${variantClass[variant]}`}>{children}</span>;
}
